export default __webpack_public_path__ + "48682933c7d19edd3c96cc7d6d4ee257.png";